import { Dispatch } from '@reduxjs/toolkit';
import { request } from '../../utils/http';

const productUri = '/product';

export function getProductApi(dispatch: Dispatch) {
	return request(dispatch, productUri);
}
